import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { DataService } from '../interfaces/DataService';
import { Router } from '@angular/router';
import { Importer } from '../clases/Importer';
import { ImportEnum } from '../enums/Import';
import { INeo4jData } from '../interfaces/INeo4jData';
import { ISchemaTree } from '../interfaces/SchemaTree';
import { createSchemaTreeRecursive } from '../utils/utils';
import { LoginResponse } from '../interfaces/LoginResponse';
import { AuthService } from './auth.service';
import { UserAttr } from '../interfaces/admin/Users';

export const LOCAL_STORAGE_JWT_TOKEN = "TOKEN";
export const LOCAL_STORAGE_DATA_SERVICE = "DATA_SERVICE";
export const LOCAL_STORAGE_CURRENT_CONNECTION = "LOCAL_STORAGE_CURRENT_CONNECTION";
export const LOCAL_STORAGE_SIM_MODEL = "LOCAL_STORAGE_SIM_MODEL";
export const LOCAL_STORAGE_USER_ATTR = "USER_ATTR";

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private router: Router, private injector: Injector) { }

  private _access_token: string = "";
  private _refresh_token: string | undefined;
  private _data_service!: DataService | undefined;
  private _data_services!: DataService[] | undefined;
  private _default_database_connection!: INeo4jData | undefined;
  private _data_services_data: INeo4jData[] = [];
  private _user_attr!: UserAttr | undefined;

  set access_token(token: string){
    this._access_token = token;
  }

  get access_token():string {
    return this._access_token;
  }

  set refresh_token(token: string){
    this._refresh_token = token;
    localStorage.setItem(LOCAL_STORAGE_JWT_TOKEN, token);
  }

  get refresh_token():string | undefined{
    if(!this._refresh_token){
      let local_token = localStorage.getItem(LOCAL_STORAGE_JWT_TOKEN);
      this._refresh_token = local_token ? local_token : undefined;
    }
    return this._refresh_token;
  }

  set data_service(conn: DataService | undefined){
    this._data_service = conn;
  }

  get data_service(){
    return this._data_service!;
  }

  set data_services(data: DataService[]){
    this._data_services = data;
    localStorage.setItem(LOCAL_STORAGE_DATA_SERVICE, JSON.stringify(data));
  }

  get data_services(): DataService[] | undefined{
    if(!this._data_services){
      let storageString = localStorage.getItem(LOCAL_STORAGE_DATA_SERVICE);
      if(!storageString){
        return undefined;
      }
      let local_data = JSON.parse(storageString) as DataService[];
      this._data_services = local_data;
    }
    return this._data_services!;
  }

  set user_attr(data: UserAttr | undefined){
    this._user_attr = data;
    if(!data){
      localStorage.removeItem(LOCAL_STORAGE_USER_ATTR);
      return;
    }
    localStorage.setItem(LOCAL_STORAGE_USER_ATTR, JSON.stringify(data));
  }

  get user_attr(): UserAttr | undefined{
    if(!this._user_attr){
      let storageString = localStorage.getItem(LOCAL_STORAGE_USER_ATTR);
      if(!storageString){
        return undefined;
      }
      this._user_attr = JSON.parse(storageString) as UserAttr;
    }
    return this._user_attr;
  }

  set default_database_connection(data: INeo4jData){
    this._default_database_connection = data;
    localStorage.setItem(LOCAL_STORAGE_CURRENT_CONNECTION, JSON.stringify(data));
  }

  get default_database_connection(): INeo4jData | undefined{
    if(!this._default_database_connection){
      let storageString = localStorage.getItem(LOCAL_STORAGE_CURRENT_CONNECTION) as string;
      if(!storageString){
        this.clearTokens();
        this.router.navigate(['/login']);
        return;
      }
      let local_dataservice = JSON.parse(storageString) as INeo4jData;
      let blank = this.createBlankTemplate(local_dataservice.dataService.data_service_id);
      this._data_services_data.push(blank);
      this._default_database_connection = blank;
    }
    return this._default_database_connection;
  }

  get data_service_data(){
    let data = this.getCurrentDataServiceData();
    if(!data){
      let data = this.createBlankTemplate(this.data_service!.data_service_id);
      this._data_services_data.push(data);
    }
    return data!;
  }

  set data_service_data(newdata: INeo4jData){
    let data = this.getCurrentDataServiceData();
    if(!data){
      data = this.createBlankTemplate(this.data_service!.data_service_id);
      this._data_services_data.push(data);
    }
    // if(!data) return;
    data.DBlabels = newdata.DBlabels;
    data.DBrelations = newdata.DBrelations;
    data.schemaTree = newdata.schemaTree;
    data.hierarchy = newdata.hierarchy;
  }

  getCurrentDataServiceData(): INeo4jData | undefined{
    let id = this.data_service!.data_service_id;
    return this._data_services_data.find((data: INeo4jData)=>data.dataService.data_service_id === id);
  }

  createBlankTemplate(id: string){
    let findDataService = this.data_services!.find(service => service.data_service_id === id);
    return {
      dataService: findDataService,
      DBrelations: [],
      DBlabels: [],
      hierarchy: [],
      schemaTree: [],
    } as INeo4jData;
  }

  clearTokens() {
    this._access_token = undefined!;
    this._user_attr = undefined;
    localStorage.setItem(LOCAL_STORAGE_JWT_TOKEN, "");
    localStorage.setItem(LOCAL_STORAGE_DATA_SERVICE, "");
    localStorage.setItem(LOCAL_STORAGE_CURRENT_CONNECTION, "");
    localStorage.removeItem(LOCAL_STORAGE_USER_ATTR);
  }
}
